import { useState, useEffect } from "react";
import { useFries } from "../../../../providers/FriesContext";
import { useValue } from "../../../../providers/ValueContext";
import HeaderTools from "../../../../Components/ComponentsIndustry/HeaderTools";
import FooterButton from "../../../../Components/ComponentsIndustry/FooterButton";
import SubHeaderPcp from "../../../../Components/ComponentsIndustry/SubHeaderPcp";
import SalesPredctionCard from "../../../../Components/ComponentsIndustry/SalesPredctionCard";
import InputCardPcp from "../../../../Components/ComponentsIndustry/InputCardPcp";
import { useMachinery } from "../../../../providers/MachineryContext";
import axios from "axios";

import { Container, SizeContainer, ContainerInput } from "./style";
import { useUser } from "../../../../providers/UserContext";

const ToolsPcpFries = () => {
  const { infoFries, setInfoFries, insumosFries, getFriesStock } = useFries();
  const { maquinaFries } = useMachinery()

  const { lossesPercentagem, setLossesPercentagem } = useValue();

  let [friesPrevSales, setFriesPrevSales] = useState(0);
  let [friesStock, setFriesStock] = useState(0);
  let [costUnit, setCostUnit] = useState(0);
  let [friesPrevProductions, setFriesPrevProductions] = useState(0);
  let [friesProductRecipe, setFriesProductRecipe] = useState(0);
  let [priceUnit, setPriceUnit] = useState(0);

  const { user, rodada, industry } = useUser()

  // const storagedUser = JSON.parse(localStorage.getItem('@App:user'));

  function handlePcp() {

    // const data = {
    //   "custoUnitario": costUnit,
    //   "industria": {
    //     "industria": storagedUser.industria.industria,
    //   },
    //   "planejamentoProducao": friesProductRecipe,
    //   "previsaoPerda": 3,
    //   "previsaoProducao": friesPrevProductions,
    //   "previsaoVenda": friesPrevSales,
    //   "produto": {
    //     "produto": 10,
    //   },
    //   "rodada": 1,
    //   "usuario": {
    //     "usuario": storagedUser.usuario
    //   }
    // }

    const data = {
      "custoUnitario": costUnit,
      "industria": {
        industria: industry?.industria
      },
      "planejamentoProducao": friesProductRecipe,
      "previsaoPerda": lossesPercentagem,
      "previsaoProducao": friesPrevProductions,
      "previsaoVenda": friesPrevSales,
      "produto": {
        "produto": 10,
      },
      "rodada": rodada,
      "usuario": user
    }

    axios.post("https://sistemas.sisinfor.com.br/BusinessGameBack/api/pcp/cadastrar", data)
      .then(response => fetchPCP())
      .catch(error => console.log(error))

  }

  useEffect(() => {
    if (!industry?.industria) return
    setLossesPercentagem(3 - industry?.funcControleQualidade ?? 0)
  }, [industry])

  useEffect(() => {

    setFriesStock(infoFries.estoque)

  }, [infoFries])

  useEffect(() => {

    setCostUnit(
      infoFries.custoUnitario
    );

    setPriceUnit(
      infoFries.preco
    );

    setFriesPrevProductions(
      parseFloat((friesPrevSales - friesStock) * ((100 - lossesPercentagem) / 100) < 0 ? 0 : Math.round((friesPrevSales - friesStock) * ((100 - lossesPercentagem) / 100))).toFixed(2)
    );

    setFriesProductRecipe(
      parseFloat(friesPrevSales * priceUnit.toFixed(2))
    );



    // setInfoFries({
    //   previsaoVendas: friesPrevSales,
    //   estoque: friesStock,
    //   previsaoProducao: friesPrevProductions,
    //   custoUnitario: costUnit,
    //   receitaProduto: friesProductRecipe,
    //   pesoCaixa: infoFries.pesoCaixa,
    // });
  }, [
    setInfoFries,
    setFriesPrevProductions,
    lossesPercentagem,
    friesProductRecipe,
    friesPrevSales,
    friesStock,
    friesPrevProductions,
    costUnit,
    rodada
  ]);

  const fetchPCP = async () => {
    axios.get(`https://sistemas.sisinfor.com.br/BusinessGameBack/api/pcp/obterPCP/${industry?.industria}/${rodada?.rodada}/10`)
      .then((response) => {
        if (response.data.previsaoVenda) {
          setFriesPrevSales(response.data.previsaoVenda)
        }
      })
  }

  useEffect(() => {
    if (!rodada?.rodada) return
    fetchPCP()
  }, [rodada])

  useEffect(() => {

    getFriesStock()

  })

  return (
    <Container>
      <SizeContainer>
        <HeaderTools
          pathImg="./images/pcp_button.svg"
          title="PCP"
          subTitle="(Planejamento Controle de Produção)"
          style={["selection", "", "", "", ""]}
        />

        <SubHeaderPcp
          style={["", "", "", "selection"]}
          product="Batata Frita"
          unity="Caixa de 1 Kg"
        />

        {maquinaFries.amount >= 1 ? (
          <>
            <ContainerInput>
              {insumosFries?.map((insumo, key) => {
                return (
                  <InputCardPcp
                    path={`${insumo.insumo.urlImagem}`}
                    title={insumo.insumo.nome}
                    value={`${insumo.quantidade}`}
                  />
                )
              })}

            </ContainerInput>

            <SalesPredctionCard
              state1={friesStock}
              setState1={setFriesStock}
              state2={friesPrevProductions}
              setState2={setFriesPrevProductions}
              state3={friesPrevSales}
              setState3={setFriesPrevSales}
              state4={costUnit}
              setState4={setCostUnit}
              state5={priceUnit}
              total={friesProductRecipe}
              setTotal={setFriesProductRecipe}
              percentagem={lossesPercentagem}
            />

            <FooterButton
              text="Confirmar"
              path="/toolsPurchasePig"
              onHandle={() => handlePcp()}
            />
          </>
        ) : (
          <ContainerInput style={{ color: "white", padding: 20, display: "flex", justifyContent: "center", alignItems: "center" }}>
            <div>ADQUIRA O MAQUINÁRIO PARA PRODUZIR ESTE PRODUTO</div>
          </ContainerInput>
        )}

      </SizeContainer>
    </Container>
  );
};
export default ToolsPcpFries;
